function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 55,
  r: 51,
  fill: "#F2F2F9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#login-circle_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 55,
  r: 42.774,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.568 64.03a2.8 2.8 0 10-3.96-3.96 2.8 2.8 0 003.96 3.96z",
  stroke: "#FB4246",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.685 58.295c.83 2.49.208 5.186-1.66 7.002a8.475 8.475 0 01-1.037.882",
  stroke: "#FB4246",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.15 70.224c5.386 0 9.751-4.366 9.751-9.75 0-5.386-4.365-9.751-9.75-9.751s-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75z",
  stroke: "#FB4246",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M61.85 57.154l3.422-3.423.208-3.527 3.526-.207.104-3.423 3.89-.57-.467-5.758-5.86-.57-9.44 9.44M59.982 50.671l8.195-8.246",
  stroke: "#FB4246",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "login-circle_svg__filter0_d",
  x: 0.226,
  y: 0.226,
  width: 115.548,
  height: 115.548,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.443137 0 0 0 0 0.454902 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgLoginCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgLoginCircle;